export class Home {
  secaoPrincipal: Info;
  secaoComoFunciona: Info;
  secaoPilares: Info;
  secaoDeslogado: Info;
  secaoProdutosPresenciais: Info;
  secaoProdutosDigitais: Info;
  secaoArtigos: Info;
  secaoEncontros: Info;
  eventos: Event[]

  constructor() {
    this.secaoPrincipal = new Info();
    this.secaoComoFunciona = new Info();
    this.secaoPilares = new Info();
    this.secaoDeslogado = new Info();
    this.secaoProdutosPresenciais = new Info();
    this.secaoProdutosDigitais = new Info();
    this.secaoArtigos = new Info();
    this.secaoEncontros = new Info();
    this.eventos = [];
  }
}

class Info {
  titulo: string;
  subTitulo: string;
  path: string;
  conteudo: any;

  constructor() {
    this.titulo = null;
    this.subTitulo = null;
    this.path = null;
    this.conteudo = null;
  }
}

class Event {
  id: null;
  titulo: null;
  pathImagem: null;
  periodos: null;
  cidades: {
    id: null,
    idCidade: null,
    descricao: null,
  }[]
}
